import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

import { RouteLinkActiveOptions } from "./route-link-active.model";

@Injectable({
	providedIn: "root",
})
export class RouteLinkActiveConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getClassName(): string {
		return this.configService.get((x) => x.router.linkActive.className, "active");
	}

	getMatchExact(): boolean {
		return this.configService.get((x) => x.router.linkActive.matchExact, true);
	}

	getIgnoreQueryParams(): boolean {
		return this.configService.get((x) => x.router.linkActive.ignoreQueryParams, false);
	}

	getOptions(): RouteLinkActiveOptions {
		return {
			cssClass: this.getClassName(),
			matchExact: this.getMatchExact(),
			ignoreQueryParams: this.getIgnoreQueryParams(),
		};
	}
}
